// // import React, { useState } from 'react';
// // import { Line } from 'react-chartjs-2';
// // import {
// //   Chart as ChartJS,
// //   CategoryScale,
// //   LinearScale,
// //   PointElement,
// //   LineElement,
// //   Title,
// //   Tooltip,
// //   Legend
// // } from 'chart.js';

// // // Register required components
// // ChartJS.register(
// //   CategoryScale,
// //   LinearScale,
// //   PointElement,
// //   LineElement,
// //   Title,
// //   Tooltip,
// //   Legend
// // );

// // const defaultColors = [
// //   'rgba(75, 192, 192, 1)',
// //   'rgba(255, 99, 132, 1)',
// //   'rgba(54, 162, 235, 1)'
// // ];

// // const LineChart = ({ data, cityNames, satelliteData = [] }) => {
// //   // State for controlling which satellite data to show
// //   const [showSST, setShowSST] = useState(false);
// //   const [showChlorophyll, setShowChlorophyll] = useState(false);
  
// //   // State for hover tooltips
// //   const [hoveredTooltip, setHoveredTooltip] = useState(null);

// //   // Calculate metadata for tooltips
// //   const calculateMetadata = (dataType) => {
// //     const filteredData = satelliteData.filter(d => d.data_type === dataType);
// //     if (filteredData.length === 0) return null;
    
// //     const values = filteredData.map(d => d.value);
// //     const dates = filteredData.map(d => new Date(d.date)).sort((a, b) => a - b);
    
// //     const avg = values.reduce((sum, val) => sum + val, 0) / values.length;
// //     const min = Math.min(...values);
// //     const max = Math.max(...values);
    
// //     const dateRange = dates.length > 0 ? {
// //       start: dates[0].toISOString().split('T')[0],
// //       end: dates[dates.length - 1].toISOString().split('T')[0]
// //     } : null;

// //     return {
// //       count: filteredData.length,
// //       avg: Math.round(avg * 100) / 100,
// //       min: Math.round(min * 100) / 100,
// //       max: Math.round(max * 100) / 100,
// //       dateRange
// //     };
// //   };

// //   const formatDate = (dateString) => {
// //     if (!dateString) return 'N/A';
// //     return new Date(dateString).toLocaleDateString('en-US', {
// //       month: 'short',
// //       day: 'numeric',
// //       year: 'numeric'
// //     });
// //   };

// //   // Early return if no data to prevent processing empty arrays
// //   if (!data || data.length === 0) {
// //     return (
// //       <div className="mt-8 flex items-center justify-center h-64 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
// //         <div className="text-center">
// //           <p className="text-gray-500 text-lg">No data available</p>
// //           <p className="text-gray-400 text-sm">Select a location on the map to view data</p>
// //         </div>
// //       </div>
// //     );
// //   }

// //   // Ensure an array of names
// //   const names = Array.isArray(cityNames) ? cityNames : [cityNames || 'Data'];

// //   // Use only DSP dates for the main time axis to maintain consistent intervals
// //   const dspDates = data.map(item => item.properties.date);
// //   const allDates = Array.from(new Set(dspDates)).sort();

// //   // Prepare datasets: one per city for DSP
// //   const datasets = names.map((name, idx) => {
// //     const color = defaultColors[idx % defaultColors.length];
// //     // Map data points aligned to allDates
// //     const dspValues = allDates.map(date => {
// //       const found = data.find(
// //         item => item.properties.name === name && item.properties.date === date
// //       );
// //       return found ? found.properties.amount : null;
// //     });

    

// //     return {
// //       label: name,
// //       data: dspValues,
// //       fill: false,
// //       borderColor: color,
// //       borderWidth: 0,
// //       tension: 0,
// //       pointRadius: 4,
// //       pointBackgroundColor: color,
// //       pointStyle: 'circle'
// //     };
// //   });

// //   // Add SST dataset if enabled and we have satellite data
// //   // Note: Satellite data is mapped to DSP timeline to maintain consistent time intervals
// //   if (showSST && satelliteData && satelliteData.length > 0) {
// //     const sstData = satelliteData.filter(d => d.data_type === 'sst');
// //     if (sstData.length > 0) {
// //       const sstValues = allDates.map(date => {
// //         const found = sstData.find(item => item.date === date);
// //         return found ? found.value : null;
// //       });

// //       datasets.push({
// //         label: 'Sea Surface Temperature (°C)',
// //         data: sstValues,
// //         fill: false,
// //         borderColor: 'rgba(239, 68, 68, 1)', // Red color
// //         borderWidth: 0,
// //         tension: 0,
// //         pointRadius: 4,
// //         pointBackgroundColor: 'rgba(239, 68, 68, 1)',
// //         pointStyle: 'circle',
// //         yAxisID: 'y1'
// //       });
// //     }
// //   }

// //   // Add Chlorophyll dataset if enabled and we have satellite data
// //   // Note: Satellite data is mapped to DSP timeline to maintain consistent time intervals
// //   if (showChlorophyll && satelliteData && satelliteData.length > 0) {
// //     const chlorophyllData = satelliteData.filter(d => d.data_type === 'chlorophyll');
// //     if (chlorophyllData.length > 0) {
// //       const chlorophyllValues = allDates.map(date => {
// //         const found = chlorophyllData.find(item => item.date === date);
// //         return found ? found.value : null;
// //       });

// //       datasets.push({
// //         label: 'Chlorophyll (mg/m³)',
// //         data: chlorophyllValues,
// //         fill: false,
// //         borderColor: 'rgb(12, 162, 12)', // Green color
// //         borderWidth: 0,
// //         tension: 0,
// //         pointRadius: 4, 
// //         pointBackgroundColor: 'rgb(12, 162, 12)', 
// //         pointStyle: 'circle',
// //         yAxisID: 'y2'
// //       });
// //     }
// //   }

// //   const chartData = {
// //     labels: allDates,
// //     datasets
// //   };

// //   // Build scales - add additional y-axes for satellite data
// //   const scales = {
// //     x: {
// //       type: 'category',
// //       title: {
// //         display: true,
// //         text: 'Date',
// //         font: { size: 14 }
// //       },
// //       ticks: {
// //         autoSkip: true,
// //         maxRotation: 45,
// //         minRotation: 0
// //       }
// //     },
// //     y: {
// //       title: {
// //         display: true,
// //         text: 'DSP Value (μg/g)',
// //         font: { size: 14 }
// //       },
// //       beginAtZero: true,
// //       position: 'left'
// //     }
// //   };

// //   // Add SST y-axis if SST is shown
// //   if (showSST && satelliteData && satelliteData.some(d => d.data_type === 'sst')) {
// //     scales.y1 = {
// //       type: 'linear',
// //       display: true,
// //       position: 'right',
// //       title: {
// //         display: true,
// //         text: 'Temperature (°C)',
// //         font: { size: 14 }
// //       },
// //       grid: {
// //         drawOnChartArea: false,
// //       },
// //     };
// //   }

// //   // Add Chlorophyll y-axis if Chlorophyll is shown
// //   if (showChlorophyll && satelliteData && satelliteData.some(d => d.data_type === 'chlorophyll')) {
// //     scales.y2 = {
// //       type: 'linear',
// //       display: true,
// //       position: 'right',
// //       title: {
// //         display: true,
// //         text: 'Chlorophyll (mg/m³)',
// //         font: { size: 14 }
// //       },
// //       grid: {
// //         drawOnChartArea: false,
// //       },
// //       // Offset if we already have y1
// //       ...(scales.y1 ? { offset: true } : {})
// //     };
// //   }

// //   const options = {
// //     responsive: true,
// //     plugins: {
// //       legend: {
// //         display: true,
// //         position: 'bottom',      // place legend at bottom
// //         align: 'center',         // center align
// //         labels: {
// //           usePointStyle: true,   // use point style instead of box
// //           pointStyle: 'circle',  // shape of legend symbol
// //           boxWidth: 10,          // smaller box width
// //           boxHeight: 10,         // smaller box height
// //           padding: 20,           // space between legend items
// //           color: '#333',         // legend font color
// //           font: {
// //             size: 12,            // legend font size
// //             family: 'Arial, sans-serif',
// //             weight: 'normal'
// //           }
// //         }
// //       },
// //       title: {
// //         display: true,
// //         text: `Data Over Time${names.length > 1 ? ': ' + names.join(', ') : ''}`,
// //         font: {
// //           size: 16,
// //           family: 'Arial, sans-serif'
// //         }
// //       },
// //       tooltip: {
// //         mode: 'nearest'
// //       }
// //     },
// //     scales
// //   };

// //   return (
// //     <div className="space-y-4">
// //       {/* Satellite Data Toggle Controls */}
// //       {satelliteData && satelliteData.length > 0 && (
// //         <div className="flex flex-wrap gap-4 justify-center p-3 bg-gray-50 rounded-lg border border-gray-200 relative">
// //           <div className="flex items-center gap-4">
// //             {satelliteData.some(d => d.data_type === 'sst') && (
// //               <label className="flex items-center">
// //                 <input
// //                   type="checkbox"
// //                   checked={showSST}
// //                   onChange={(e) => setShowSST(e.target.checked)}
// //                   className="mr-2 rounded border-gray-300 text-red-600 focus:ring-red-500"
// //                 />
// //                 <span className="text-sm text-gray-700">Sea Surface Temperature</span>
// //                 <div className="relative ml-1">
// //                   <div
// //                     className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center cursor-help text-white text-xs hover:bg-gray-500 transition-colors"
// //                     onMouseEnter={() => setHoveredTooltip('sst')}
// //                     onMouseLeave={() => setHoveredTooltip(null)}
// //                   >
// //                     i
// //                   </div>
// //                   {hoveredTooltip === 'sst' && (
// //                     <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-xs z-50">
// //                       {(() => {
// //                         const metadata = calculateMetadata('sst');
// //                         return metadata ? (
// //                           <div className="space-y-1">
// //                             <div className="font-semibold text-gray-700 border-b border-gray-200 pb-1">SST Data</div>
// //                             <div className="flex justify-between">
// //                               <span className="text-gray-600">Points:</span>
// //                               <span className="font-medium">{metadata.count}</span>
// //                             </div>
// //                             <div className="flex justify-between">
// //                               <span className="text-gray-600">Average:</span>
// //                               <span className="font-medium">{metadata.avg}°C</span>
// //                             </div>
// //                             <div className="flex justify-between">
// //                               <span className="text-gray-600">Range:</span>
// //                               <span className="font-medium">{metadata.min} - {metadata.max}°C</span>
// //                             </div>
// //                             {metadata.dateRange && (
// //                               <div className="text-gray-600 text-center mt-1 pt-1 border-t border-gray-200">
// //                                 {formatDate(metadata.dateRange.start)} to {formatDate(metadata.dateRange.end)}
// //                               </div>
// //                             )}
// //                           </div>
// //                         ) : (
// //                           <div className="text-gray-500">No SST data available</div>
// //                         );
// //                       })()}
// //                     </div>
// //                   )}
// //                 </div>
// //               </label>
// //             )}
            
// //             {satelliteData.some(d => d.data_type === 'chlorophyll') && (
// //               <label className="flex items-center">
// //                 <input
// //                   type="checkbox"
// //                   checked={showChlorophyll}
// //                   onChange={(e) => setShowChlorophyll(e.target.checked)}
// //                   className="mr-2 rounded border-gray-300 text-green-600 focus:ring-green-500"
// //                 />
// //                 <span className="text-sm text-gray-700">Chlorophyll</span>
// //                 <div className="relative ml-1">
// //                   <div
// //                     className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center cursor-help text-white text-xs hover:bg-gray-500 transition-colors"
// //                     onMouseEnter={() => setHoveredTooltip('chlorophyll')}
// //                     onMouseLeave={() => setHoveredTooltip(null)}
// //                   >
// //                     i
// //                   </div>
// //                   {hoveredTooltip === 'chlorophyll' && (
// //                     <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-xs z-50">
// //                       {(() => {
// //                         const metadata = calculateMetadata('chlorophyll');
// //                         return metadata ? (
// //                           <div className="space-y-1">
// //                             <div className="font-semibold text-gray-700 border-b border-gray-200 pb-1">Chlorophyll Data</div>
// //                             <div className="flex justify-between">
// //                               <span className="text-gray-600">Points:</span>
// //                               <span className="font-medium">{metadata.count}</span>
// //                             </div>
// //                             <div className="flex justify-between">
// //                               <span className="text-gray-600">Average:</span>
// //                               <span className="font-medium">{metadata.avg} mg/m³</span>
// //                             </div>
// //                             <div className="flex justify-between">
// //                               <span className="text-gray-600">Range:</span>
// //                               <span className="font-medium">{metadata.min} - {metadata.max} mg/m³</span>
// //                             </div>
// //                             {metadata.dateRange && (
// //                               <div className="text-gray-600 text-center mt-1 pt-1 border-t border-gray-200">
// //                                 {formatDate(metadata.dateRange.start)} to {formatDate(metadata.dateRange.end)}
// //                               </div>
// //                             )}
// //                           </div>
// //                         ) : (
// //                           <div className="text-gray-500">No chlorophyll data available</div>
// //                         );
// //                       })()}
// //                     </div>
// //                   )}
// //                 </div>
// //               </label>
// //             )}
// //           </div>
// //         </div>
// //       )}

// //       {/* Chart */}
// //       <div className="mt-8">
// //         <Line data={chartData} options={options} />
// //       </div>
// //     </div>
// //   );
// // };

// // export default LineChart;

// import React, { useState } from 'react';
// import { Line } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend
// } from 'chart.js';

// // Register required components
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const defaultColors = [
//   'rgba(75, 192, 192, 1)',
//   'rgba(255, 99, 132, 1)',
//   'rgba(54, 162, 235, 1)'
// ];

// const LineChart = ({ data, cityNames, satelliteData = [] }) => {
//   // State for controlling which satellite data to show
//   const [showSST, setShowSST] = useState(false);
//   const [showChlorophyll, setShowChlorophyll] = useState(false);
  
//   // State for hover tooltips
//   const [hoveredTooltip, setHoveredTooltip] = useState(null);

//   // Calculate metadata for tooltips
//   const calculateMetadata = (dataType) => {
//     const filteredData = satelliteData.filter(d => d.data_type === dataType);
//     if (filteredData.length === 0) return null;
    
//     const values = filteredData.map(d => d.value);
//     const dates = filteredData.map(d => new Date(d.date)).sort((a, b) => a - b);
    
//     const avg = values.reduce((sum, val) => sum + val, 0) / values.length;
//     const min = Math.min(...values);
//     const max = Math.max(...values);
    
//     const dateRange = dates.length > 0 ? {
//       start: dates[0].toISOString().split('T')[0],
//       end: dates[dates.length - 1].toISOString().split('T')[0]
//     } : null;

//     return {
//       count: filteredData.length,
//       avg: Math.round(avg * 100) / 100,
//       min: Math.round(min * 100) / 100,
//       max: Math.round(max * 100) / 100,
//       dateRange
//     };
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       month: 'short',
//       day: 'numeric',
//       year: 'numeric'
//     });
//   };

//   // Helper function to find toxin data for a specific point
//   const findToxinData = (locationName, date) => {
//     return data.find(item => 
//       item.properties.name === locationName && 
//       item.properties.date === date
//     );
//   };

//   // Early return if no data to prevent processing empty arrays
//   if (!data || data.length === 0) {
//     return (
//       <div className="mt-8 flex items-center justify-center h-64 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
//         <div className="text-center">
//           <p className="text-gray-500 text-lg">No data available</p>
//           <p className="text-gray-400 text-sm">Select a location on the map to view data</p>
//         </div>
//       </div>
//     );
//   }

//   // Ensure an array of names
//   const names = Array.isArray(cityNames) ? cityNames : [cityNames || 'Data'];

//   // Use only DSP dates for the main time axis to maintain consistent intervals
//   const dspDates = data.map(item => item.properties.date);
//   const allDates = Array.from(new Set(dspDates)).sort();

//   // Prepare datasets: one per city for DSP
//   const datasets = names.map((name, idx) => {
//     const color = defaultColors[idx % defaultColors.length];
//     // Map data points aligned to allDates
//     const dspValues = allDates.map(date => {
//       const found = data.find(
//         item => item.properties.name === name && item.properties.date === date
//       );
//       return found ? found.properties.amount : null;
//     });

//     return {
//       label: name,
//       data: dspValues,
//       fill: false,
//       borderColor: color,
//       borderWidth: 0,
//       tension: 0,
//       pointRadius: 4,
//       pointBackgroundColor: color,
//       pointStyle: 'circle'
//     };
//   });

//   // Add SST dataset if enabled and we have satellite data
//   if (showSST && satelliteData && satelliteData.length > 0) {
//     const sstData = satelliteData.filter(d => d.data_type === 'sst');
//     if (sstData.length > 0) {
//       const sstValues = allDates.map(date => {
//         const found = sstData.find(item => item.date === date);
//         return found ? found.value : null;
//       });

//       datasets.push({
//         label: 'Sea Surface Temperature (°C)',
//         data: sstValues,
//         fill: false,
//         borderColor: 'rgba(239, 68, 68, 1)', // Red color
//         borderWidth: 0,
//         tension: 0,
//         pointRadius: 4,
//         pointBackgroundColor: 'rgba(239, 68, 68, 1)',
//         pointStyle: 'circle',
//         yAxisID: 'y1'
//       });
//     }
//   }

//   // Add Chlorophyll dataset if enabled and we have satellite data
//   if (showChlorophyll && satelliteData && satelliteData.length > 0) {
//     const chlorophyllData = satelliteData.filter(d => d.data_type === 'chlorophyll');
//     if (chlorophyllData.length > 0) {
//       const chlorophyllValues = allDates.map(date => {
//         const found = chlorophyllData.find(item => item.date === date);
//         return found ? found.value : null;
//       });

//       datasets.push({
//         label: 'Chlorophyll (mg/m³)',
//         data: chlorophyllValues,
//         fill: false,
//         borderColor: 'rgb(12, 162, 12)', // Green color
//         borderWidth: 0,
//         tension: 0,
//         pointRadius: 4, 
//         pointBackgroundColor: 'rgb(12, 162, 12)', 
//         pointStyle: 'circle',
//         yAxisID: 'y2'
//       });
//     }
//   }

//   const chartData = {
//     labels: allDates,
//     datasets
//   };

//   // Build scales - add additional y-axes for satellite data
//   const scales = {
//     x: {
//       type: 'category',
//       title: {
//         display: true,
//         text: 'Date',
//         font: { size: 14 }
//       },
//       ticks: {
//         autoSkip: true,
//         maxRotation: 45,
//         minRotation: 0
//       }
//     },
//     y: {
//       title: {
//         display: true,
//         text: 'DSP Value (μg/g)',
//         font: { size: 14 }
//       },
//       beginAtZero: true,
//       position: 'left'
//     }
//   };

//   // Add SST y-axis if SST is shown
//   if (showSST && satelliteData && satelliteData.some(d => d.data_type === 'sst')) {
//     scales.y1 = {
//       type: 'linear',
//       display: true,
//       position: 'right',
//       title: {
//         display: true,
//         text: 'Temperature (°C)',
//         font: { size: 14 }
//       },
//       grid: {
//         drawOnChartArea: false,
//       },
//     };
//   }

//   // Add Chlorophyll y-axis if Chlorophyll is shown
//   if (showChlorophyll && satelliteData && satelliteData.some(d => d.data_type === 'chlorophyll')) {
//     scales.y2 = {
//       type: 'linear',
//       display: true,
//       position: 'right',
//       title: {
//         display: true,
//         text: 'Chlorophyll (mg/m³)',
//         font: { size: 14 }
//       },
//       grid: {
//         drawOnChartArea: false,
//       },
//       // Offset if we already have y1
//       ...(scales.y1 ? { offset: true } : {})
//     };
//   }

//   const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         display: true,
//         position: 'bottom',
//         align: 'center',
//         labels: {
//           usePointStyle: true,
//           pointStyle: 'circle',
//           boxWidth: 10,
//           boxHeight: 10,
//           padding: 20,
//           color: '#333',
//           font: {
//             size: 12,
//             family: 'Arial, sans-serif',
//             weight: 'normal'
//           }
//         }
//       },
//       title: {
//         display: true,
//         text: `Data Over Time${names.length > 1 ? ': ' + names.join(', ') : ''}`,
//         font: {
//           size: 16,
//           family: 'Arial, sans-serif'
//         }
//       },
//       tooltip: {
//         mode: 'point',
//         intersect: false,
//         callbacks: {
//           title: function(context) {
//             return `Date: ${context[0].label}`;
//           },
//           label: function(context) {
//             const datasetLabel = context.dataset.label;
//             const value = context.raw;
            
//             // Handle satellite data tooltips
//             if (datasetLabel.includes('Sea Surface Temperature')) {
//               return `${datasetLabel}: ${value}°C`;
//             }
//             if (datasetLabel.includes('Chlorophyll')) {
//               return `${datasetLabel}: ${value} mg/m³`;
//             }
            
//             // Handle DSP data tooltips with toxin information
//             const locationName = datasetLabel;
//             const date = context.label;
//             const toxinData = findToxinData(locationName, date);
            
//             let tooltipLines = [`${locationName}: ${value} μg/g`];
            
//             if (toxinData) {
//               const toxin = toxinData.properties.toxin || toxinData.properties.toxin_type;
//               if (toxin && toxin.trim() !== "") {
//                 tooltipLines.push(`Toxin Type: ${toxin}`);
//               }
              
//               // Add any other relevant properties you want to show
//               if (toxinData.properties.species) {
//                 tooltipLines.push(`Species: ${toxinData.properties.species}`);
//               }
              
//               if (toxinData.properties.sample_id) {
//                 tooltipLines.push(`Sample ID: ${toxinData.properties.sample_id}`);
//               }
//             }
            
//             return tooltipLines;
//           }
//         },
//         backgroundColor: 'rgba(0, 0, 0, 0.8)',
//         titleColor: 'white',
//         bodyColor: 'white',
//         borderColor: 'rgba(255, 255, 255, 0.2)',
//         borderWidth: 1,
//         cornerRadius: 6,
//         displayColors: true,
//         padding: 10
//       }
//     },
//     scales,
//     interaction: {
//       mode: 'point',
//       intersect: false
//     }
//   };

//   return (
//     <div className="space-y-4">
//       {/* Satellite Data Toggle Controls */}
//       {satelliteData && satelliteData.length > 0 && (
//         <div className="flex flex-wrap gap-4 justify-center p-3 bg-gray-50 rounded-lg border border-gray-200 relative">
//           <div className="flex items-center gap-4">
//             {satelliteData.some(d => d.data_type === 'sst') && (
//               <label className="flex items-center">
//                 <input
//                   type="checkbox"
//                   checked={showSST}
//                   onChange={(e) => setShowSST(e.target.checked)}
//                   className="mr-2 rounded border-gray-300 text-red-600 focus:ring-red-500"
//                 />
//                 <span className="text-sm text-gray-700">Sea Surface Temperature</span>
//                 <div className="relative ml-1">
//                   <div
//                     className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center cursor-help text-white text-xs hover:bg-gray-500 transition-colors"
//                     onMouseEnter={() => setHoveredTooltip('sst')}
//                     onMouseLeave={() => setHoveredTooltip(null)}
//                   >
//                     i
//                   </div>
//                   {hoveredTooltip === 'sst' && (
//                     <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-xs z-50">
//                       {(() => {
//                         const metadata = calculateMetadata('sst');
//                         return metadata ? (
//                           <div className="space-y-1">
//                             <div className="font-semibold text-gray-700 border-b border-gray-200 pb-1">SST Data</div>
//                             <div className="flex justify-between">
//                               <span className="text-gray-600">Points:</span>
//                               <span className="font-medium">{metadata.count}</span>
//                             </div>
//                             <div className="flex justify-between">
//                               <span className="text-gray-600">Average:</span>
//                               <span className="font-medium">{metadata.avg}°C</span>
//                             </div>
//                             <div className="flex justify-between">
//                               <span className="text-gray-600">Range:</span>
//                               <span className="font-medium">{metadata.min} - {metadata.max}°C</span>
//                             </div>
//                             {metadata.dateRange && (
//                               <div className="text-gray-600 text-center mt-1 pt-1 border-t border-gray-200">
//                                 {formatDate(metadata.dateRange.start)} to {formatDate(metadata.dateRange.end)}
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <div className="text-gray-500">No SST data available</div>
//                         );
//                       })()}
//                     </div>
//                   )}
//                 </div>
//               </label>
//             )}
            
//             {satelliteData.some(d => d.data_type === 'chlorophyll') && (
//               <label className="flex items-center">
//                 <input
//                   type="checkbox"
//                   checked={showChlorophyll}
//                   onChange={(e) => setShowChlorophyll(e.target.checked)}
//                   className="mr-2 rounded border-gray-300 text-green-600 focus:ring-green-500"
//                 />
//                 <span className="text-sm text-gray-700">Chlorophyll</span>
//                 <div className="relative ml-1">
//                   <div
//                     className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center cursor-help text-white text-xs hover:bg-gray-500 transition-colors"
//                     onMouseEnter={() => setHoveredTooltip('chlorophyll')}
//                     onMouseLeave={() => setHoveredTooltip(null)}
//                   >
//                     i
//                   </div>
//                   {hoveredTooltip === 'chlorophyll' && (
//                     <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-xs z-50">
//                       {(() => {
//                         const metadata = calculateMetadata('chlorophyll');
//                         return metadata ? (
//                           <div className="space-y-1">
//                             <div className="font-semibold text-gray-700 border-b border-gray-200 pb-1">Chlorophyll Data</div>
//                             <div className="flex justify-between">
//                               <span className="text-gray-600">Points:</span>
//                               <span className="font-medium">{metadata.count}</span>
//                             </div>
//                             <div className="flex justify-between">
//                               <span className="text-gray-600">Average:</span>
//                               <span className="font-medium">{metadata.avg} mg/m³</span>
//                             </div>
//                             <div className="flex justify-between">
//                               <span className="text-gray-600">Range:</span>
//                               <span className="font-medium">{metadata.min} - {metadata.max} mg/m³</span>
//                             </div>
//                             {metadata.dateRange && (
//                               <div className="text-gray-600 text-center mt-1 pt-1 border-t border-gray-200">
//                                 {formatDate(metadata.dateRange.start)} to {formatDate(metadata.dateRange.end)}
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <div className="text-gray-500">No chlorophyll data available</div>
//                         );
//                       })()}
//                     </div>
//                   )}
//                 </div>
//               </label>
//             )}
//           </div>
//         </div>
//       )}

//       {/* Chart */}
//       <div className="mt-8">
//         <Line data={chartData} options={options} />
//       </div>
//     </div>
//   );
// };

// export default LineChart;


import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

// Register required components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const defaultColors = [
  'rgba(75, 192, 192, 1)',
  'rgba(255, 99, 132, 1)',
  'rgba(54, 162, 235, 1)'
];

const LineChart = ({ data, cityNames, satelliteData = [], selectedToxin, customizationSettings = null }) => {
  // State for controlling which satellite data to show
  const [showSST, setShowSST] = useState(false);
  const [showChlorophyll, setShowChlorophyll] = useState(false);
  
  // State for hover tooltips
  const [hoveredTooltip, setHoveredTooltip] = useState(null);

  // Get customization settings or use defaults
  const getLocationSettings = (index) => {
    if (customizationSettings?.locations?.[index]) {
      return customizationSettings.locations[index];
    }
    return {
      color: defaultColors[index % defaultColors.length],
      pointStyle: 'circle',
      pointSize: 4,
      lineWidth: 0
    };
  };

  const getSSTSettings = () => {
    if (customizationSettings?.sst) {
      return customizationSettings.sst;
    }
    return {
      color: 'rgba(239, 68, 68, 1)',
      pointStyle: 'circle',
      pointSize: 4,
      lineWidth: 0
    };
  };

  const getChlorophyllSettings = () => {
    if (customizationSettings?.chlorophyll) {
      return customizationSettings.chlorophyll;
    }
    return {
      color: 'rgb(12, 162, 12)',
      pointStyle: 'circle',
      pointSize: 4,
      lineWidth: 0
    };
  };

  const getRegulatoryLimitSettings = (toxinType) => {
    if (customizationSettings?.regulatoryLimits?.[toxinType]) {
      return customizationSettings.regulatoryLimits[toxinType];
    }
    const defaults = {
      'DSP': { color: 'rgba(255, 165, 0, 0.6)', lineWidth: 2 },
      'PSP': { color: 'rgba(255, 0, 0, 0.6)', lineWidth: 2 }
    };
    return defaults[toxinType] || { color: 'rgba(128, 128, 128, 0.6)', lineWidth: 2 };
  };

  // Regulatory limits for different toxins (in μg/kg except ASP which is mg/kg)
  const regulatoryLimits = {
    'DSP': { value: 160, unit: 'μg/kg' }, // Orange
    'PSP': { value: 800, unit: 'μg/kg' },   // Red
    // 'ASP': { value: 20000, unit: 'μg/kg', color: 'rgba(128, 0, 128, 0.6)' } // Purple (converted 20 mg/kg to μg/kg) - COMMENTED OUT: value too high, messes with chart scale
  };

  // Function to get active toxin types from current data
  const getActiveToxinTypes = () => {
    if (!data || data.length === 0) return [];
    
    const toxinTypes = new Set();
    data.forEach(item => {
      const toxin = item.properties?.toxin || item.properties?.toxin_type;
      if (toxin && toxin.trim() !== "") {
        // Normalize toxin names to match our regulatory limits
        const normalizedToxin = toxin.toUpperCase().includes('DSP') ? 'DSP' :
                               toxin.toUpperCase().includes('PSP') ? 'PSP' :
                               toxin.toUpperCase().includes('ASP') ? 'ASP' : toxin;
        if (regulatoryLimits[normalizedToxin]) {
          toxinTypes.add(normalizedToxin);
        }
      }
    });
    
    // If a specific toxin is selected, only show that one's limit
    if (selectedToxin && selectedToxin.trim() !== "") {
      const normalizedSelected = selectedToxin.toUpperCase().includes('DSP') ? 'DSP' :
                                selectedToxin.toUpperCase().includes('PSP') ? 'PSP' :
                                selectedToxin.toUpperCase().includes('ASP') ? 'ASP' : selectedToxin;
      if (regulatoryLimits[normalizedSelected]) {
        return [normalizedSelected];
      }
    }
    
    return Array.from(toxinTypes);
  };

  // Calculate metadata for tooltips
  const calculateMetadata = (dataType) => {
    const filteredData = satelliteData.filter(d => d.data_type === dataType);
    if (filteredData.length === 0) return null;
    
    const values = filteredData.map(d => d.value);
    const dates = filteredData.map(d => new Date(d.date)).sort((a, b) => a - b);
    
    const avg = values.reduce((sum, val) => sum + val, 0) / values.length;
    const min = Math.min(...values);
    const max = Math.max(...values);
    
    const dateRange = dates.length > 0 ? {
      start: dates[0].toISOString().split('T')[0],
      end: dates[dates.length - 1].toISOString().split('T')[0]
    } : null;

    return {
      count: filteredData.length,
      avg: Math.round(avg * 100) / 100,
      min: Math.round(min * 100) / 100,
      max: Math.round(max * 100) / 100,
      dateRange
    };
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  // Helper function to find toxin data for a specific point
  const findToxinData = (locationName, date) => {
    return data.find(item => 
      item.properties.name === locationName && 
      item.properties.date === date
    );
  };

  // Early return if no data to prevent processing empty arrays
  if (!data || data.length === 0) {
    return (
      <div className="mt-8 flex items-center justify-center h-64 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
        <div className="text-center">
          <p className="text-gray-500 text-lg">No data available</p>
          <p className="text-gray-400 text-sm">Select a location on the map to view data</p>
        </div>
      </div>
    );
  }

  // Ensure an array of names
  const names = Array.isArray(cityNames) ? cityNames : [cityNames || 'Data'];

  // Use only DSP dates for the main time axis to maintain consistent intervals
  const dspDates = data.map(item => item.properties.date);
  const allDates = Array.from(new Set(dspDates)).sort();

  // Prepare datasets: one per city for DSP
  const datasets = names.map((name, idx) => {
    const settings = getLocationSettings(idx);
    // Map data points aligned to allDates
    const dspValues = allDates.map(date => {
      const found = data.find(
        item => item.properties.name === name && item.properties.date === date
      );
      return found ? found.properties.amount : null;
    });

    return {
      label: name,
      data: dspValues,
      fill: false,
      borderColor: settings.color,
      borderWidth: settings.lineWidth,
      tension: 0,
      pointRadius: settings.pointSize,
      pointBackgroundColor: settings.color,
      pointStyle: settings.pointStyle
    };
  });

  // Add SST dataset if enabled and we have satellite data
  if (showSST && satelliteData && satelliteData.length > 0) {
    const sstData = satelliteData.filter(d => d.data_type === 'sst');
    if (sstData.length > 0) {
      const sstSettings = getSSTSettings();
      const sstValues = allDates.map(date => {
        const found = sstData.find(item => item.date === date);
        return found ? found.value : null;
      });

      datasets.push({
        label: 'Sea Surface Temperature (°C)',
        data: sstValues,
        fill: false,
        borderColor: sstSettings.color,
        borderWidth: sstSettings.lineWidth,
        tension: 0,
        pointRadius: sstSettings.pointSize,
        pointBackgroundColor: sstSettings.color,
        pointStyle: sstSettings.pointStyle,
        yAxisID: 'y1'
      });
    }
  }

  // Add Chlorophyll dataset if enabled and we have satellite data
  if (showChlorophyll && satelliteData && satelliteData.length > 0) {
    const chlorophyllData = satelliteData.filter(d => d.data_type === 'chlorophyll');
    if (chlorophyllData.length > 0) {
      const chlorophyllSettings = getChlorophyllSettings();
      const chlorophyllValues = allDates.map(date => {
        const found = chlorophyllData.find(item => item.date === date);
        return found ? found.value : null;
      });

      datasets.push({
        label: 'Chlorophyll (mg/m³)',
        data: chlorophyllValues,
        fill: false,
        borderColor: chlorophyllSettings.color,
        borderWidth: chlorophyllSettings.lineWidth,
        tension: 0,
        pointRadius: chlorophyllSettings.pointSize, 
        pointBackgroundColor: chlorophyllSettings.color, 
        pointStyle: chlorophyllSettings.pointStyle,
        yAxisID: 'y2'
      });
    }
  }

  // Add regulatory limit lines for active toxin types
  const activeToxins = getActiveToxinTypes();
  activeToxins.forEach(toxinType => {
    const limit = regulatoryLimits[toxinType];
    const limitSettings = getRegulatoryLimitSettings(toxinType);
    if (limit) {
      datasets.push({
        label: `${toxinType} Regulatory Limit (${limit.value} ${limit.unit})`,
        data: new Array(allDates.length).fill(limit.value),
        fill: false,
        borderColor: limitSettings.color,
        backgroundColor: limitSettings.color,
        borderWidth: limitSettings.lineWidth,
        borderDash: [10, 5], // Creates dashed line
        tension: 0,
        pointRadius: 0, // No points on limit lines
        pointHoverRadius: 0,
        pointHitRadius: 0,
        spanGaps: true,
        order: 999 // Ensure limit lines appear behind data points
      });
    }
  });

  const chartData = {
    labels: allDates,
    datasets
  };

  // Build scales - add additional y-axes for satellite data
  const scales = {
    x: {
      type: 'category',
      title: {
        display: true,
        text: 'Date',
        font: { size: 14 }
      },
      ticks: {
        autoSkip: true,
        maxRotation: 45,
        minRotation: 0
      }
    },
    y: {
      title: {
        display: true,
        text: 'DSP Value (μg/g)',
        font: { size: 14 }
      },
      beginAtZero: true,
      position: 'left'
    }
  };

  // Add SST y-axis if SST is shown
  if (showSST && satelliteData && satelliteData.some(d => d.data_type === 'sst')) {
    scales.y1 = {
      type: 'linear',
      display: true,
      position: 'right',
      title: {
        display: true,
        text: 'Temperature (°C)',
        font: { size: 14 }
      },
      grid: {
        drawOnChartArea: false,
      },
    };
  }

  // Add Chlorophyll y-axis if Chlorophyll is shown
  if (showChlorophyll && satelliteData && satelliteData.some(d => d.data_type === 'chlorophyll')) {
    scales.y2 = {
      type: 'linear',
      display: true,
      position: 'right',
      title: {
        display: true,
        text: 'Chlorophyll (mg/m³)',
        font: { size: 14 }
      },
      grid: {
        drawOnChartArea: false,
      },
      // Offset if we already have y1
      ...(scales.y1 ? { offset: true } : {})
    };
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 2,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        align: 'center',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 10,
          boxHeight: 10,
          padding: 20,
          color: '#333',
          font: {
            size: 12,
            family: 'Arial, sans-serif',
            weight: 'normal'
          }
        }
      },
      title: {
        display: true,
        text: `Data Over Time${names.length > 1 ? ': ' + names.join(', ') : ''}`,
        font: {
          size: 16,
          family: 'Arial, sans-serif'
        }
      },
      tooltip: {
        mode: 'point',
        intersect: false,
        callbacks: {
          title: function(context) {
            return `Date: ${context[0].label}`;
          },
          label: function(context) {
            const datasetLabel = context.dataset.label;
            const value = context.raw;
            
            // Handle regulatory limit lines - don't show in tooltip
            if (datasetLabel.includes('Regulatory Limit')) {
              return null; // This will hide the regulatory limit from tooltips
            }
            
            // Handle satellite data tooltips
            if (datasetLabel.includes('Sea Surface Temperature')) {
              return `${datasetLabel}: ${value}°C`;
            }
            if (datasetLabel.includes('Chlorophyll')) {
              return `${datasetLabel}: ${value} mg/m³`;
            }
            
            // Handle DSP data tooltips with toxin information
            const locationName = datasetLabel;
            const date = context.label;
            const toxinData = findToxinData(locationName, date);
            
            let tooltipLines = [`${locationName}: ${value} μg/g`];
            
            if (toxinData) {
              const toxin = toxinData.properties.toxin || toxinData.properties.toxin_type;
              if (toxin && toxin.trim() !== "") {
                tooltipLines.push(`Toxin Type: ${toxin}`);
              }
              
              // Add any other relevant properties you want to show
              if (toxinData.properties.species) {
                tooltipLines.push(`Species: ${toxinData.properties.species}`);
              }
              
              if (toxinData.properties.sample_id) {
                tooltipLines.push(`Sample ID: ${toxinData.properties.sample_id}`);
              }
            }
            
            return tooltipLines;
          }
        },
        filter: function(tooltipItem) {
          // Hide regulatory limit lines from tooltips
          return !tooltipItem.dataset.label.includes('Regulatory Limit');
        },
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: 'white',
        bodyColor: 'white',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        borderWidth: 1,
        cornerRadius: 6,
        displayColors: true,
        padding: 10
      }
    },
    scales,
    interaction: {
      mode: 'point',
      intersect: false
    }
  };

  return (
    <div className="flex flex-col h-full w-full">
      {/* Satellite Data Toggle Controls */}
      {satelliteData && satelliteData.length > 0 && (
        <div className="flex-none flex flex-wrap gap-4 justify-center p-3 bg-gray-50 rounded-lg border border-gray-200 relative mb-4">
          <div className="flex items-center gap-4">
            {satelliteData && satelliteData.some(d => d.data_type === 'sst') && (
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={showSST}
                  onChange={(e) => setShowSST(e.target.checked)}
                  className="mr-2 rounded border-gray-300 text-red-600 focus:ring-red-500"
                />
                <span className="text-sm text-gray-700">Sea Surface Temperature</span>
                <div className="relative ml-1">
                  <div
                    className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center cursor-help text-white text-xs hover:bg-gray-500 transition-colors"
                    onMouseEnter={() => setHoveredTooltip('sst')}
                    onMouseLeave={() => setHoveredTooltip(null)}
                  >
                    i
                  </div>
                  {hoveredTooltip === 'sst' && (
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-xs z-50">
                      {(() => {
                        const metadata = calculateMetadata('sst');
                        return metadata ? (
                          <div className="space-y-1">
                            <div className="font-semibold text-gray-700 border-b border-gray-200 pb-1">SST Data</div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">Points:</span>
                              <span className="font-medium">{metadata.count}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">Average:</span>
                              <span className="font-medium">{metadata.avg}°C</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">Range:</span>
                              <span className="font-medium">{metadata.min} - {metadata.max}°C</span>
                            </div>
                            {metadata.dateRange && (
                              <div className="text-gray-600 text-center mt-1 pt-1 border-t border-gray-200">
                                {formatDate(metadata.dateRange.start)} to {formatDate(metadata.dateRange.end)}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="text-gray-500">No SST data available</div>
                        );
                      })()}
                    </div>
                  )}
                </div>
              </label>
            )}
            
            {satelliteData && satelliteData.some(d => d.data_type === 'chlorophyll') && (
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={showChlorophyll}
                  onChange={(e) => setShowChlorophyll(e.target.checked)}
                  className="mr-2 rounded border-gray-300 text-green-600 focus:ring-green-500"
                />
                <span className="text-sm text-gray-700">Chlorophyll</span>
                <div className="relative ml-1">
                  <div
                    className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center cursor-help text-white text-xs hover:bg-gray-500 transition-colors"
                    onMouseEnter={() => setHoveredTooltip('chlorophyll')}
                    onMouseLeave={() => setHoveredTooltip(null)}
                  >
                    i
                  </div>
                  {hoveredTooltip === 'chlorophyll' && (
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-xs z-50">
                      {(() => {
                        const metadata = calculateMetadata('chlorophyll');
                        return metadata ? (
                          <div className="space-y-1">
                            <div className="font-semibold text-gray-700 border-b border-gray-200 pb-1">Chlorophyll Data</div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">Points:</span>
                              <span className="font-medium">{metadata.count}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">Average:</span>
                              <span className="font-medium">{metadata.avg} mg/m³</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">Range:</span>
                              <span className="font-medium">{metadata.min} - {metadata.max} mg/m³</span>
                            </div>
                            {metadata.dateRange && (
                              <div className="text-gray-600 text-center mt-1 pt-1 border-t border-gray-200">
                                {formatDate(metadata.dateRange.start)} to {formatDate(metadata.dateRange.end)}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="text-gray-500">No chlorophyll data available</div>
                        );
                      })()}
                    </div>
                  )}
                </div>
              </label>
            )}
          </div>
        </div>
      )}

      {/* Chart */}
      <div className="flex-1 min-h-0 relative w-full">
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default LineChart;